import { ApplicationEvent } from '@shared/infrastructure/app-event-bus';

export enum ExecutorEvents {
  ActionStarted = 'ActionStarted',
  ActionEvent = 'ActionEvent',
  ActionInfo = 'ActionInfo',
  ActionFinished = 'ActionFinished',
  ActionError = 'ActionError',
  ActionCancelled = 'ActionCancelled',
  NewWorksheetCreated = 'NewWorksheetCreated',
}

export class ExecutorActionStarted implements ApplicationEvent {
  type = ExecutorEvents.ActionStarted;
  constructor() {}
}

export class ExecutorActionEvent implements ApplicationEvent {
  type = ExecutorEvents.ActionEvent;
  constructor(
    public message: string,
    public description?: string,
  ) {}
}

export class ExecutorActionInfo implements ApplicationEvent {
  type = ExecutorEvents.ActionInfo;
  constructor(public message: string) {}
}

export class ExecutorActionFinished implements ApplicationEvent {
  type = ExecutorEvents.ActionFinished;
  constructor(
    public message: string,
    public result: Record<string, any>,
  ) {}
}

export class ExecutorActionError implements ApplicationEvent {
  type = ExecutorEvents.ActionError;
  constructor(public error: Error) {}
}

export class ExecutorCancelled implements ApplicationEvent {
  type = ExecutorEvents.ActionCancelled;
  constructor(public message: string) {}
}

export class ExecutorNewWorksheetCreated implements ApplicationEvent {
  type = ExecutorEvents.NewWorksheetCreated;
  constructor(public sheetName: string) {}
}
